import apiClient from './client';
import { CreateIssueSchema, UpdateIssueSchema } from 'shared-schemas';

export const issuesApi = {
  list: async (params = {}) => {
    const response = await apiClient.get('/api/issues', { params });
    return response.data;
  },
  
  get: async (id) => {
    const response = await apiClient.get(`/api/issues/${id}`);
    return response.data;
  },
  
  getByIssueNumber: async (issueNumber) => {
    // Now we can use the same endpoint since API accepts issue numbers
    const response = await apiClient.get(`/api/issues/${issueNumber}`);
    return response.data;
  },
  
  create: async (issueData) => {
    const validated = CreateIssueSchema.parse(issueData);
    const response = await apiClient.post('/api/issues', validated);
    return response.data;
  },
  
  update: async (idOrIssueNumber, issueData) => {
    // Use safeParse to validate without applying defaults
    const result = UpdateIssueSchema.safeParse(issueData);
    if (!result.success) {
      throw new Error(`Validation failed: ${result.error.message}`);
    }
    // Send the original issueData (not result.data which has defaults applied)
    const response = await apiClient.patch(`/api/issues/${idOrIssueNumber}`, issueData);
    return response.data;
  },
  
  delete: async (idOrIssueNumber) => {
    await apiClient.delete(`/api/issues/${idOrIssueNumber}`);
  },

  refreshStats: async (issueNumber) => {
    const response = await apiClient.post(`/api/issues/${issueNumber}/refresh-stats`);
    return response.data;
  },

  createSingleSend: async (issueNumber) => {
    const response = await apiClient.post(`/api/issues/${issueNumber}/single-send`);
    return response.data;
  },

  updateSingleSend: async (issueNumber) => {
    const response = await apiClient.put(`/api/issues/${issueNumber}/single-send`);
    return response.data;
  },

  previewSingleSend: async (issueNumber) => {
    const response = await apiClient.get(`/api/issues/${issueNumber}/single-send/preview`, {
      responseType: 'text',
      transformResponse: [(data) => data],
    });
    return response.data;
  },
};